import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {DomEventsService} from "../dom-event-services/dom-events.service";

@Injectable({
  providedIn: 'root'
})
export class GroupDomService {
  public _activeGroup$ = new BehaviorSubject<any>(null);
  public _activeGroupInputDOM$ = new BehaviorSubject<any>(null);
  set activeGroup$(val:any){
    this._activeGroup$.next(val)
  }
  get activeGroup$(){
    return this._activeGroup$.asObservable();
  }
  set activeGroupInputDOM$(val:any){
    this._activeGroupInputDOM$.next(val)
  }
  get activeGroupInputDOM(){
    return this._activeGroupInputDOM$.getValue();
  }

  get activeGroupVal(){
    return this._activeGroup$.getValue();
  }

  private _position = {left: 0, top: 0};
  set position(val){
    this._position = val
  }
  get position(){
    return this._position;
  }
  private _isVisible$ = new BehaviorSubject<boolean>(false);
  set isVisible$(val:any){
    this._isVisible$.next(val);
  }
  get isVisible$(){
    return this._isVisible$.asObservable();
  }

  constructor(private domEvents: DomEventsService) { }

}
